import React, { useCallback, useState } from 'react'
import { AuthTemplateView } from '~/components'
import { RecoverPasswordForm } from './components'
import { useHistory } from 'react-router-dom'
import { trackEvent, AuthActions } from '~/service/analytics'

export const RecoverPassword: React.FC = () => {
  const [passwordRecoverySuccess, setPasswordRecoverySuccess] = useState(false)

  const history = useHistory()

  const redirectToLogin = useCallback(() => {
    trackEvent(AuthActions.GO_TO_LOGIN)
    history.push('/')
  }, [history, trackEvent])

  if (passwordRecoverySuccess) {
    return (
      <AuthTemplateView
        title='Solicitação enviada'
        description='Recebemos sua solicitação. Se existir um cadastro relacionado a CNPJ você receberá uma mensagem de recuperação de senha em seu e-mail com instruções para a recuperação de senha! Não se esqueça de verificar a caixa de spam.'
        onBackButtonClick={redirectToLogin}
      />
    )
  }

  return (
    <RecoverPasswordForm
      onPasswordRecoverySuccess={setPasswordRecoverySuccess}
      redirectToLogin={redirectToLogin}
    />
  )
}
